import React from "react";
import styles from "./FeaturedEvents.module.css";
import Image from "next/image";
import { CalendarDays, Globe, MapPin } from "lucide-react";
import Link from "next/link";

const FeaturedEvents = ({ data }: any) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{data.title}</h2>
      <div className="row">
        {data.feature_event_cards.map((event: any) => {
          // Determine if the card should be clickable and what URL to use
          const hasLink = event.type_link && event.type_link.url;
          const linkUrl = hasLink ? event.type_link.url : "#";

          // Create the card content
          const cardContent = (
            <>
              <Image
                src={event.image.url}
                alt={event.image.alternativeText || event.event_card.title}
                width={387}
                height={200}
                className={styles.cardImgTop}
              />
              <div className={`${styles.cardBody}`}>
                {/* Event type badge if available */}
                {event.type_link && event.type_link.label && (
                  <div className={styles.eventType}>
                    {event.type_link.label}
                  </div>
                )}

                <div className="d-flex justify-content-between">
                  <span className="d-flex align-items-center gap-2">
                    <CalendarDays size={20} color="#18463E" />
                    {new Date(event.event_card.date_time).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </span>

                  <span className="d-flex align-items-center gap-2">
                    <Image
                      src="/assets/Clock.svg"
                      alt={"clock"}
                      width={20}
                      height={20}
                    />
                    {new Date(event.event_card.date_time)
                      .toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      .toLowerCase()}
                  </span>
                </div>
                <h5 className={styles.eventTitle}>{event.event_card.title}</h5>
                <div className={styles.eventLocation}>
                  {event.event_card.location.toLowerCase() === "online" ? (
                    <Globe size={20} />
                  ) : (
                    <MapPin size={20} />
                  )}
                  <span className={styles.eventLocationTitle}>
                    {event.event_card.location}
                  </span>
                </div>
              </div>
            </>
          );

          return (
            <div className="col-md-4 mb-4 mt-4" key={event.id}>
              {hasLink ? (
                <Link href={linkUrl} className={styles.cardLink}>
                  <div
                    className={`${styles.card} ${
                      hasLink ? styles.clickable : ""
                    }`}
                  >
                    {cardContent}
                  </div>
                </Link>
              ) : (
                <div className={styles.card}>{cardContent}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturedEvents;
